/* Saint Texas quote page (27 Sep 2026) — sections/st-quote.liquid.
   One question per card (27 Sep, Steve): decoration → product → where it goes → how many → Get your quote.
   ?method=screen|dtf|emb picks the decoration and starts on the product question (Back still reaches step 1).
   Products + print spots from the Worker (GET /api/quote-builder/products); "Get your quote" checks the choices
   (POST check:true). 17 Oct: "See my price" posts preview:true and shows the price right away (no email); the optional
   "Email me this quote" box then posts the email → lead saved + quote emailed by the Worker.
   ?mq=<id> (29 Sep): the "View your quote" button in an email from our assistant — fills every step in from
   GET /api/quote-builder/mq/<id> (re-priced today) and shows the price right away, no email needed. */
(function () {
  "use strict";
  var root = document.getElementById("st-quote"); if (!root) return;
  var API = (root.getAttribute("data-api") || "https://api.sainttexas.com").replace(/\/$/, "");
  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var NAMES = { screen: "Screen printing", dtf: "Direct to Film", emb: "Embroidery" };
  var st = { method: null, products: [], min: {}, product: null, spots: {}, step: 0 };
  var STEPS = ["method", "product", "spots", "qty"];
  /* product-type chips (garment from the Worker, src/filters.js garmentOf) */
  var CAT_ORDER = ["T-Shirt", "Hoodie", "Long Sleeve Tee", "Sweatshirt", "Quarter-Zip", "Tank Top", "Polo", "Jacket", "Bottoms", "Tote", "Bag", "Towel", "Flag", "Can Cooler", "Workwear", "Headwear"];
  var CAT_LABEL = { "T-Shirt": "T-Shirts", "Hoodie": "Hoodies", "Long Sleeve Tee": "Long Sleeves", "Sweatshirt": "Sweatshirts", "Quarter-Zip": "Quarter-Zips", "Tank Top": "Tanks", "Polo": "Polos", "Jacket": "Outerwear", "Bottoms": "Bottoms", "Tote": "Totes", "Bag": "Bags", "Towel": "Towels", "Flag": "Flags", "Can Cooler": "Can Coolers", "Workwear": "Workwear", "Headwear": "Hats" };
  var norm = function (x) { return String(x || "").toUpperCase().replace(/[^A-Z0-9]/g, ""); };
  var POPULAR = (root.getAttribute("data-popular") || "").split(",").map(norm).filter(Boolean);
  var NOT_SURE = (root.getAttribute("data-default") || "5000, 6601").split(",").map(norm).filter(Boolean);   /* shirt default + hat default */
  st.cat = "";

  var q = new URLSearchParams(location.search), m0 = (q.get("method") || "").toLowerCase();
  if (m0 === "embroidery" || m0 === "puff") m0 = "emb"; if (m0 === "screen-printing") m0 = "screen"; if (m0 === "direct-to-film") m0 = "dtf";

  function valid(i) {
    if (i === 0) return !!st.method;
    if (i === 1) return !!st.product;
    if (i === 2) return Object.keys(st.spots).some(function (k) { return st.spots[k] > 0; });
    return parseInt($("#stq-qty").value, 10) > 0;
  }
  function goStep(i) {
    st.step = Math.max(0, Math.min(STEPS.length - 1, i));
    STEPS.forEach(function (name, k) { var el = $('[data-step="' + name + '"]'); if (el) el.hidden = k !== st.step; });
    $(".stq__count").textContent = "Step " + (st.step + 1) + " of " + STEPS.length;
    $(".stq__bar i").style.width = ((st.step + 1) / STEPS.length * 100) + "%";
    $(".stq__back").hidden = st.step === 0;
    var last = st.step === STEPS.length - 1;
    $(".stq__next").hidden = last; $(".stq__go").hidden = !last;
    err(""); update();
    var f = st.step === 1 ? $(".stq__chip") : st.step === 3 ? $("#stq-qty") : null;
    if (f && document.activeElement && root.contains(document.activeElement)) setTimeout(function () { f.focus(); }, 30);
  }
  function err(t) { var e = $(".stq__err"); e.textContent = t || ""; e.hidden = !t; }
  /* 29 Sep: each product lists the methods it takes (polos emb/DTF, jackets emb/screen, bags·vests·overalls emb, hats emb/puff) */
  function takes(p, m) { return p.methods ? p.methods.indexOf(m) >= 0 : (m === "emb") === (p.kind === "hat"); }
  function hatPicked() { return !!(st.product && st.product.kind === "hat"); }
  function method() { return st.method === "emb" && hatPicked() && $("#stq-puff").checked ? "puff" : st.method; }

  function setMethod(m, lock) {
    st.method = NAMES[m] ? m : null;
    $$(".stq__method").forEach(function (b) { b.setAttribute("aria-checked", String(b.getAttribute("data-m") === st.method)); });
    fillProducts(); err("");
  }
  /* chips: garment type for shirts; brand for hats (Embroidery) — Steve, 27 Sep */
  function groupOf(p) { return p.garment || ""; }
  function groupLabel(c) { return CAT_LABEL[c] || c; }
  function listFor() { return st.products.filter(function (p) { return takes(p, st.method); }); }
  function popRank(p) { var i = POPULAR.indexOf(norm(p.code)); return i; }
  function fillProducts() {
    if (!st.method) { update(); return; }
    var list = listFor();
    /* chips: the types this decoration has, then "I'm not sure" */
    var cats = [];
    list.forEach(function (p) { var g = groupOf(p); if (g && cats.indexOf(g) < 0) cats.push(g); });
    cats.sort(function (a, b) { var ia = CAT_ORDER.indexOf(a), ib = CAT_ORDER.indexOf(b); return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || a.localeCompare(b); });
    if (st.cat && cats.indexOf(st.cat) < 0) st.cat = "";
    /* 11 Oct (Steve): no product dropdown, the chip is the pick (its most affordable product prices the quote) */
    $(".stq__chips").innerHTML = cats.map(function (c) { return '<button type="button" class="stq__chip" data-cat="' + esc(c) + '" aria-pressed="' + (st.cat === c) + '">' + esc(groupLabel(c)) + "</button>"; }).join("") +
      (list.length ? '<button type="button" class="stq__chip stq__chip--unsure" data-unsure>I’m not sure</button>' : "");
    fillSelect();
    $(".stq__puff").hidden = !(st.method === "emb" && hatPicked());
  }
  function fillSelect() {
    var sel = $("#stq-product"), list = listFor().filter(function (p) { return !st.cat || groupOf(p) === st.cat; });
    var keep = st.product && list.indexOf(st.product) >= 0 ? st.product.handle : (!st.product && q.get("product")) || "";
    var pop = list.filter(function (p) { return popRank(p) >= 0; }).sort(function (a, b) { return popRank(a) - popRank(b); });
    var rest = list.filter(function (p) { return pop.indexOf(p) < 0; });
    var opt = function (p) { return '<option value="' + esc(p.handle) + '"' + (p.handle === keep ? " selected" : "") + ">" + esc(p.title) + "</option>"; };
    sel.innerHTML = '<option value="">' + (list.length ? "Choose a product" : "No products for this decoration yet") + "</option>" +
      (pop.length ? '<optgroup label="Most popular">' + pop.map(opt).join("") + "</optgroup>" + (rest.length ? '<optgroup label="' + esc(st.cat ? "All " + groupLabel(st.cat).toLowerCase() : "Everything else") + '">' + rest.map(opt).join("") + "</optgroup>" : "") : rest.map(opt).join(""));
    pickProduct(sel.value);
  }
  function notSure() {
    var list = listFor();
    var p = list.filter(function (x) { return NOT_SURE.indexOf(norm(x.code)) >= 0; }).sort(function (a, b) { return NOT_SURE.indexOf(norm(a.code)) - NOT_SURE.indexOf(norm(b.code)); })[0] ||
      list.filter(function (x) { return popRank(x) >= 0; }).sort(function (a, b) { return popRank(a) - popRank(b); })[0] || list[0];
    if (!p) return;
    st.cat = ""; fillProducts();
    $("#stq-product").value = p.handle; pickProduct(p.handle);
    goStep(2);
  }
  function pickCat(c) {
    var list = listFor().filter(function (x) { return groupOf(x) === c; });
    /* the most affordable product in that type (Worker sends each one's 50-piece "from" price); popular as a fallback */
    var priced = list.filter(function (x) { return x.from > 0; }).sort(function (a, b) { return a.from - b.from || popRank(a) - popRank(b); });
    var p = priced[0] || list.filter(function (x) { return popRank(x) >= 0; }).sort(function (a, b) { return popRank(a) - popRank(b); })[0] || list[0];
    if (!p) return;
    st.cat = c; $$(".stq__chip[data-cat]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-cat") === c)); });
    fillSelect(); $("#stq-product").value = p.handle; pickProduct(p.handle);
    goStep(2);
  }
  function pickProduct(h) {
    st.product = st.products.filter(function (p) { return p.handle === h; })[0] || null;
    var img = $(".stq__img");
    if (st.product && st.product.img) { img.src = st.product.img; img.hidden = false; } else img.hidden = true;
    if (st.product) {
      /* keep choices for spots the new product also has */
      var old = st.spots; st.spots = {};
      st.product.spots.forEach(function (s) { if (old[s.key]) st.spots[s.key] = Math.min(old[s.key], st.method === "screen" ? s.max : 1); });
      if (!Object.keys(st.spots).length && st.product.spots[0]) st.spots[st.product.spots[0].key] = 1;
      drawSpots();
    }
    $(".stq__puff").hidden = !(st.method === "emb" && hatPicked());
    var mn = st.min[method()] || 0; $(".stq__min").textContent = mn ? NAMES[st.method] + " starts at " + mn + " pieces." : "";
    update();
  }
  function drawSpots() {
    var box = $(".stq__spots"), m = st.method;
    var disc = $(".stq__disc");
    if (m === "screen") disc.textContent = "This quote assumes solid spot colors (no gradients or photos \u2014 those print as Direct to Film), standard plastisol ink, and a print that fits the spot (full front up to about 12\" wide). Specialty inks like metallic or glow-in-the-dark and exact Pantone matches aren\u2019t included. We\u2019ll check your art before anything is printed, and let you know if it needs changes.";
    else if (m === "emb") disc.textContent = disc.getAttribute("data-emb") || disc.textContent;
    disc.hidden = m !== "emb" && m !== "screen";
    $(".stq__hint").textContent = m === "screen" ? "Pick how many ink colors go on each spot." : m === "dtf" ? "Tick each spot you want printed — full color." : "Tick each spot you want stitched.";
    box.innerHTML = st.product.spots.map(function (s) {
      var v = st.spots[s.key] || 0, ctl;
      if (m === "screen") {
        var o = '<option value="0">No print</option>';
        for (var i = 1; i <= s.max; i++) o += '<option value="' + i + '"' + (v === i ? " selected" : "") + ">" + i + " color" + (i > 1 ? "s" : "") + "</option>";
        ctl = '<select data-spot="' + esc(s.key) + '" aria-label="Colors on ' + esc(s.name) + '">' + o + "</select>";
      } else {
        var word = m === "dtf" ? "Full color" : (s.view === "front" && hatPicked() && $("#stq-puff").checked ? "Puff embroidery" : "Embroidery");
        ctl = '<label class="stq__tog"><input type="checkbox" data-spot="' + esc(s.key) + '"' + (v ? " checked" : "") + "> " + word + "</label>";
      }
      return '<div class="stq__spot"><b>' + esc(s.name) + "</b>" + ctl + "</div>";
    }).join("");
  }
  function ready() { return valid(0) && valid(1) && valid(2) && valid(3); }
  function update() {
    var n = $(".stq__next"); n.disabled = !valid(st.step); $(".stq__go").disabled = !ready();
    n.hidden = st.step === STEPS.length - 1 || (st.step === 0 && !st.method);
  }
  function body(extra) {
    var b = { handle: st.product.handle, method: method(), qty: parseInt($("#stq-qty").value, 10), spots: st.spots };
    for (var k in extra) b[k] = extra[k];
    return b;
  }
  function post(b) {
    return fetch(API + "/api/quote-builder", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(b), credentials: "omit" })
      .then(function (r) { return r.json(); }).catch(function () { return { ok: false, error: "We couldn't reach our pricing. Please try again in a minute." }; });
  }

  /* modal */
  var modal = $(".stq__modal");
  function openModal() { modal.hidden = false; document.body.style.overflow = "hidden"; }
  function closeModal() { modal.hidden = true; document.body.style.overflow = ""; }
  var HV = (window.ST_HV_RATE > 0 && window.ST_HV_RATE < 90) ? window.ST_HV_RATE : 0;   /* high volume client: % off shown (snippets/st-hv.liquid) */
  function money(n) { n = Number(n) || 0; if (HV) n = Math.round(n * (100 - HV)) / 100; return "$" + n.toFixed(2); }
  function result(r, email) {
    var store = location.origin;
    var res = $(".stq__res"); res.hidden = false;
    res.innerHTML = "<h2>Your quote</h2><p>" + esc(r.title) + " · " + esc(r.method) + "</p>" +
      '<div class="stq__price"><b>' + money(r.per) + "</b><span>each · " + money(r.total) + " total</span></div>" +
      (HV ? '<p style="margin:6px 0 0;color:#1d6b2f;font-weight:600">Includes your ' + HV + "% high volume discount.</p>" : "") +
      '<ul class="stq__rows"><li><span>Pieces</span><span>' + r.qty + "</span></li>" +
      r.deco.map(function (d) { var i = d.indexOf(": "); return "<li><span>" + esc(d.slice(0, i)) + "</span><span>" + esc(d.slice(i + 2)) + "</span></li>"; }).join("") +
      "<li><span>Standard in-hands date</span><span>" + esc(r.deliveryLabel) + "</span></li></ul>" +
      '<p class="stq__note">' + esc(r.basis) + "</p>" +
      (r.fromEmail ? '<p class="stq__note">This is the quote from our email, priced today. Change anything below and get a new price anytime.</p>' : r.preview ? saveBox() : '<p class="stq__note">' + (r.emailed ? "We also sent this quote to " + esc(email) + "." : "We couldn't email it just now — this is your quote.") + "</p>") +
      '<div class="stq__acts"><a class="stq__btn" href="' + store + "/pages/design?product=" + encodeURIComponent(r.handle) + "&method=" + encodeURIComponent(r.methodKey) + '">Start designing</a>' +
      (r.fromEmail ? '<button type="button" class="stq__btn stq__btn--ghost" data-change>Change something</button>' : '<button type="button" class="stq__btn stq__btn--ghost" data-again>Quote another product</button>') + "</div>";
  }

  /* 17 Oct (Steve: the email ask before the price scared people off): the price shows first, then this optional
     "Email me this quote" box. Saving it is what creates the lead (hub → Leads → Quote page) and sends the email. */
  function saveBox() {
    return '<div class="stq__save"><b>Email me this quote</b><ul><li>Saved in your inbox to come back to</li><li>10% off your first order</li><li>Free proof before we print</li></ul>' +
      '<form class="stq__form stq__saveform"><span class="stq__field"><input type="email" class="stq__email" required placeholder=" " autocomplete="email" aria-label="Email"><span class="stq__ph" aria-hidden="true">you@company.com</span></span>' +
      '<button type="submit" class="stq__send">Email me my quote</button></form><p class="stq__ferr" role="alert" hidden></p></div>';
  }
  function track(ev) { try { if (window.clarity) window.clarity("event", ev); } catch (x) {} }

  root.addEventListener("click", function (e) {
    var t = e.target.closest ? e.target.closest("button") : null; if (!t) { if (e.target === modal) closeModal(); return; }
    if (t.classList.contains("stq__method")) { setMethod(t.getAttribute("data-m"), false); goStep(1); }
    else if (t.hasAttribute("data-unsure")) notSure();
    else if (t.hasAttribute("data-cat")) pickCat(t.getAttribute("data-cat"));
    else if (t.classList.contains("stq__next")) { if (valid(st.step)) goStep(st.step + 1); }
    else if (t.classList.contains("stq__back")) goStep(st.step - 1);
    else if (t.classList.contains("stq__x")) closeModal();
    else if (t.hasAttribute("data-again")) { closeModal(); goStep(1); }
    else if (t.hasAttribute("data-change")) { closeModal(); goStep(3); }
    else if (t.classList.contains("stq__go")) {
      if (!ready()) return; t.disabled = true; err("");
      post(body({ preview: true })).then(function (r) { t.disabled = false; if (!r.ok) { err(r.error); if (r.min) $("#stq-qty").value = r.min; update(); return; } openModal(); result(r, ""); track("quote_price_shown"); });
    }
  });
  root.addEventListener("change", function (e) {
    var t = e.target;
    if (t.id === "stq-product") pickProduct(t.value);
    else if (t.id === "stq-puff") { if (st.product) drawSpots(); var mn = st.min[method()] || 0; $(".stq__min").textContent = mn ? NAMES[st.method] + " starts at " + mn + " pieces." : ""; }
    else if (t.hasAttribute("data-spot")) { st.spots[t.getAttribute("data-spot")] = t.type === "checkbox" ? (t.checked ? 1 : 0) : parseInt(t.value, 10) || 0; err(""); update(); }
  });
  $("#stq-qty").addEventListener("input", function () { var v = this.value.replace(/[^0-9]/g, "").slice(0, 5); if (v !== this.value) this.value = v; err(""); update(); });
  $("#stq-qty").addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); var g = $(".stq__go"); if (!g.disabled) g.click(); } });
  root.addEventListener("submit", function (e) {
    if (!e.target.classList || !e.target.classList.contains("stq__saveform")) return;
    e.preventDefault();
    var f = e.target, btn = f.querySelector(".stq__send"), email = f.querySelector(".stq__email").value.trim(), fe = f.parentNode.querySelector(".stq__ferr");
    btn.disabled = true; btn.textContent = "Sending…"; fe.hidden = true;
    post(body({ email: email })).then(function (r) {
      btn.disabled = false; btn.textContent = "Email me my quote";
      if (!r.ok) { fe.textContent = r.error; fe.hidden = false; return; }
      track("quote_saved");
      f.parentNode.innerHTML = '<b>Sent to ' + esc(email) + '</b><p class="stq__note" style="margin:6px 0 0">' + (r.emailed ? "Check your inbox for your quote." : "Your quote is saved. We'll be in touch.") + ' First order? Use code <b>FIRSTORDER10</b> at checkout for 10% off.</p>';
    });
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !modal.hidden) closeModal(); });

  fetch(API + "/api/quote-builder/products", { credentials: "omit" }).then(function (r) { return r.json(); }).then(function (j) {
    if (!j.ok) throw 0;
    st.products = j.products || []; st.min = j.min || {};
    setMethod(NAMES[m0] ? m0 : null); goStep(NAMES[m0] ? 1 : 0);
    if (/^[\w-]{8,40}$/.test(q.get("mq") || "")) fromEmail(q.get("mq"));
  }).catch(function () { $("#stq-product").innerHTML = '<option value="">Products couldn’t load — please refresh</option>'; setMethod(NAMES[m0] ? m0 : null); goStep(NAMES[m0] ? 1 : 0); });
  /* the emailed quote: fill every step in and show the price */
  function fromEmail(id) {
    fetch(API + "/api/quote-builder/mq/" + encodeURIComponent(id), { credentials: "omit" }).then(function (r) { return r.json(); }).then(function (r) {
      if (!r.ok || !r.params) { err(r.error || "That quote link has expired — build a new one below."); return; }
      var p = r.params;
      setMethod(p.method === "puff" ? "emb" : p.method);
      if (p.method === "puff") $("#stq-puff").checked = true;
      $("#stq-product").value = p.handle; pickProduct(p.handle);
      if (!st.product) { err("That product isn't available any more — pick another."); goStep(1); return; }
      st.spots = {}; for (var k in p.spots) st.spots[k] = p.spots[k]; drawSpots();
      $("#stq-qty").value = p.qty; goStep(3);
      openModal(); result(r, "");
    }).catch(function () { err("We couldn't load your quote — build it below."); });
  }
  goStep(0);
})();
